import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
// import PropTypes from 'prop-types';
import { Typography, Card, Grid, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import PerformanceScoreCard from './timetracker/PerformanceScoreCard';
import CustomCard from '../components/card/CustomCard';
import { performanceData } from '../services/performanceService';
import AppWidgetSummary from '../components/card/AppWidgetSummary';
import { getMyTaskFilteredTask } from '../services/taskService';
// import { isAdmin } from '../utils/share';
import getTaskDueCategory from '../utils/getTaskDueCategory';
import DashboardAppPage from './DashboardAppPage';

export default function Dashboard() {
  const [score, setScore] = useState(0);
  const [breakpoints, setBreakpoints] = useState([]);
  const [scoreLoading, setScoreLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState({
    pendingTask: 0,
    dueToday: 0,
    dueTomorrow: 0,
    dueThisWeek: 0,
    overDueTask: 0,
    overSpendTask: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPerformanceData = async () => {
      try {
        const currentDate = new Date();
        let month = currentDate.getMonth();
        let year = currentDate.getFullYear();

        if (month === 0) {
          month = 12;
          year -= 1;
        }
        setScoreLoading(true);
        const res = await performanceData({ month, year });
        setBreakpoints(res.data.data?.breakpoints);
        setScore(res.data.data);
        setScoreLoading(false);
      } catch (error) {
        setScoreLoading(false);
        console.error('Error fetching performance data: ', error);
      }
    };

    const getMyTaskFilteredTasks = async (status = null) => {
      try {
        setLoading(true);
        const response = await getMyTaskFilteredTask({
          pageSize: 'all',
          filters: JSON.stringify([]),
          sorting: JSON.stringify([]),
          status,
          // start: pagination.pageIndex * pagination.pageSize,
          // globalFilter,
          // status: currentTab,
        });
        // Initialize default counts
        const initialCounts = {
          pendingTask:
            response?.data?.data?.inProgressCount +
              response?.data?.data?.notStartedCount +
              response?.data?.data?.blockedCount || 0,
          dueToday: 0,
          dueTomorrow: 0,
          dueThisWeek: 0,
          overDueTask: 0,
          overSpendTask: 0,
        };

        // Iterate over tasks to calculate dynamic counts
        response?.data?.data?.rows?.forEach((task) => {
          // if (status !== null) {
          const dueCategory = getTaskDueCategory(task.endDate);
          if (dueCategory === 'dueToday') {
            initialCounts.dueToday += 1;
            initialCounts.dueThisWeek += 1; // Also count in dueThisWeek
          } else if (dueCategory === 'dueTomorrow') {
            initialCounts.dueTomorrow += 1;
            initialCounts.dueThisWeek += 1; // Also count in dueThisWeek
          } else if (dueCategory === 'dueThisWeek') {
            initialCounts.dueThisWeek += 1; // Count only in dueThisWeek
          }
          // }

          if (
            task.endDate &&
            new Date(task.endDate) < ((task.completedAt && new Date(task.completedAt)) || new Date())
          ) {
            initialCounts.overDueTask += 1;
          }

          // Check if the task is overdue (consumed hours > planned hours)
          if (task.plannedHours < task.consumedHours) {
            initialCounts.overSpendTask += 1;
          }
        });

        // Set the final counts
        setCount(initialCounts);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error('Error fetching performance data: ', error);
      }
    };

    fetchPerformanceData();
    getMyTaskFilteredTasks();
    // getMyTaskFilteredTasks("completed");
  }, []);

  return (
    <>
      <Helmet>
        <title> Task Dashboard </title>
      </Helmet>

      <Typography variant="h6" gutterBottom ml={2}>
        Task Dashboard
      </Typography>

      <Grid container spacing={4} pl={2} pr={2} justifyContent="center">
        <Grid item container xs={12} md={8} spacing={4}>
          <Grid container item spacing={4}>
            <Grid item xs={12} sm={6} md={4}>
              <CustomCard
                value={count.pendingTask}
                label="Pending Task"
                bgColor="linear-gradient(to right, #FFA726 0%, rgba(255,167,38,0) 100%)"
                iconURL="\assets\icons\ic-courses-progress.svg"
                loading={loading}
                onClick={() => navigate('/mytask/table')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CustomCard
                value={count.dueToday}
                label="Due Today"
                bgColor="linear-gradient(135deg, #22C55E 0%, #065E49 100%);"
                iconURL="\assets\icons\ic-courses-completed.svg"
                onClick={() => navigate('/mytask/table?today=true')}
                // onClick={() => navigate(`/mytask/table?startTime=${today.start}&endTime=${today.end}`)}
                loading={loading}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CustomCard
                value={count.dueTomorrow}
                label="Due Tomorrow"
                bgColor="linear-gradient(135deg, #8E33FF 0%, #5119B7 100%);"
                iconURL="\assets\icons\ic_due_tomorrow.svg"
                onClick={() => navigate('/mytask/table?tomorrow=true')}
                // onClick={() => navigate(`/mytask/table?startTime=${tomorrow.start}&endTime=${tomorrow.end}`)}
                loading={loading}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CustomCard
                value={count.dueThisWeek}
                label="Due This Week"
                bgColor="linear-gradient(135deg, #2289c5 0%, #06355e 100%);"
                iconURL="\assets\icons\ic_due_this_week.svg"
                // onClick={() => navigate(`/mytask/table?startTime=${thisWeek.start}&endTime=${thisWeek.end}`)}
                onClick={() => navigate('/mytask/table?week=true')}
                loading={loading}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CustomCard
                value={count.overDueTask}
                label="Over Due Task"
                iconURL="\assets\icons\ic_overdue-task.svg"
                bgColor="linear-gradient(135deg, #f13030 0%, #bb1313 100%)"
                onClick={() => navigate('/mytask/table?overdue=true')}
                loading={loading}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CustomCard
                value={count.overSpendTask}
                label="Over Spend Task"
                bgColor="linear-gradient(135deg, #803D3B 0%, #803D3B 100%)"
                iconURL="\assets\icons\ic_overrun-task.svg"
                onClick={() => navigate('/mytask/table?overrun=true')}
                loading={loading}
              />
            </Grid>
            {/* 2 */}

            {/* <Grid item xs={12} sm={4}>
              <AppWidgetSummary
                title="Over Due Task"
                value={15}
                // sx={{ backgroundColor: colors[4] }}
                onClick={() => navigate('/mytask/table')}
                loading={loading}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <AppWidgetSummary
                title="Over Spend Task"
                value={155}
                // sx={{ backgroundColor: colors[4] }}
                onClick={() => navigate('/mytask/table')}
                loading={loading}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <AppWidgetSummary
                title="Normal Task"
                value={115}
                // sx={{ backgroundColor: colors[5] }}
                onClick={() => navigate('/mytask/table')}
                loading={loading}
              />
            </Grid> */}

            {/* <Grid item xs={12}>
              <IssueOverviewCard data={data} loading={loading} />
            </Grid> */}
          </Grid>
        </Grid>

        {/* Score card */}
        <Grid item xs={12} sm={12} md={4}>
          <Card
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 2,
              transition: 'box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out', // Smooth transition for visual effects
              '&:hover': {
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', // Shadow effect on hover
              },
            }}
          >
            {scoreLoading ? (
              <CircularProgress color="inherit" />
            ) : (
              <PerformanceScoreCard breakpoints={breakpoints} score={score} position="static" />
            )}
          </Card>
        </Grid>

        <Grid container item xs={12} sm={12} md={12} spacing={4}>
          {/* <Grid item xs={12} sm={6} md={4}>
            <CustomCard
              value={count.overDueTask}
              label="Over Due Task"
              iconURL="\assets\icons\ic_overrun-task.svg"
              bgColor="linear-gradient(to right, #f13030 0%, #bb1313 100%)"
              onClick={() => navigate('/mytask/table?overdue=true')}
              loading={loading}
              />
          </Grid>
          <Grid item xs={12} sm={6} md={4} spacing={4}>
            <CustomCard
              value={count.overSpendTask}
              label="Over Spend Task"
              bgColor="linear-gradient(to right, #f13030 0%, #bb1313 100%)"
              iconURL="\assets\icons\ic_overdue-task.svg"
              onClick={() => navigate('/mytask/table?overrun=true')}
              loading={loading}
            />
          </Grid> */}
          {/* <Grid item xs={12} sm={6} md={4} spacing={4}>
            <CustomCard
              value={0}
              label="All Tasks"
              bgColor="linear-gradient(to right, #f13030 0%, #bb1313 100%)"
              iconURL="\assets\icons\ic-courses-progress-red.svg"
              onClick={() => navigate('/mytask/table')}
              loading={loading}
            />
          </Grid> */}
        </Grid>

        {/* third */}
        {false && (
          <>
            <Grid item xs={12} sm={6} md={6}>
              <AppWidgetSummary
                title="Projects Exceeding Allocated Hours"
                value={5}
                // sx={{ backgroundColor: colors[0] }}
                onClick={() => navigate('/mytask/table')}
                loading={loading}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <AppWidgetSummary
                title="Projects Exceeding Timeline"
                value={15}
                // sx={{ backgroundColor: colors[1] }}
                onClick={() => navigate('/mytask/table')}
                loading={loading}
              />
              {/* fourth */}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <AppWidgetSummary
                title="Active Team members"
                value={15}
                // sx={{ backgroundColor: colors[2] }}
                onClick={() => navigate('/mytask/table')}
                loading={loading}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <AppWidgetSummary
                title="Inactive Team members"
                value={15}
                // sx={{ backgroundColor: colors[3] }}
                onClick={() => navigate('/mytask/table')}
                loading={loading}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <AppWidgetSummary
                title="Team Members Not Logged In"
                value={15}
                // sx={{ backgroundColor: colors[3] }}
                onClick={() => navigate('/mytask/table')}
                loading={loading}
              />
            </Grid>
          </>
        )}

        <Grid item xs={12} sm={12} md={12}>
          <DashboardAppPage />
        </Grid>
      </Grid>
    </>
  );
}
